import { noop } from '@domain/utils/function.utils';

export const stalledPromise = new Promise(noop);

export function getStalledPromise<R>(data?: R) {
  return stalledPromise as Promise<R>;
}
